import React from 'react';
import TopicsAgentPage from '../components/TopicsAgentPage';
import { API_ENDPOINTS } from '../config/api';
import { loadProductTopicGroups } from '../data/productArticleTopics';
import { resolveTofuClusterKey, TOFU_CLUSTER_PRODUCT_HINTS } from '../data/tofuClusterKeys';

const TOFUArticlesAgentPage: React.FC = () => (
  <TopicsAgentPage
    pageTitle="TOFU 100 Articles"
    pageDescription="Generate top-of-funnel problem-aware articles grouped by plant category. Each cluster links to the mapped pillar or pest products."
    storageKeyPrefix="tofu_articles_agent"
    generateAsyncUrl={API_ENDPOINTS.tofuArticlesGenerateAsync}
    getJobStatusUrl={API_ENDPOINTS.tofuArticlesJobStatus}
    clusterKeyFromGroupName={resolveTofuClusterKey}
    clusterProductHints={TOFU_CLUSTER_PRODUCT_HINTS}
    loadGroups={() =>
      loadProductTopicGroups({
        path: '/keywords/tofu_100_blogs.csv',
        prefix: 'tofu',
      })
    }
  />
);

export default TOFUArticlesAgentPage;
